module.exports = __webpack_public_path__ + "img/map.6a32d1d4.png";